// Shared helpers and components for the billing module.
import React from 'react';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'upi', label: 'UPI' },
  { value: 'card', label: 'Card' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'insurance', label: 'Insurance' },
];

export const fmtINR = (n) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '—';
  return `₹${Number(n).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
};

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return iso; }
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  try { return new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }); }
  catch { return iso; }
};

export const STATUS_BADGE = {
  draft:                'bg-slate-100 text-slate-700 border-slate-300',
  partial:              'bg-amber-100 text-amber-800 border-amber-300',
  paid:                 'bg-emerald-100 text-emerald-800 border-emerald-300',
  refunded:             'bg-blue-100 text-blue-800 border-blue-300',
  partially_refunded:   'bg-indigo-100 text-indigo-800 border-indigo-300',
  cancelled:            'bg-rose-100 text-rose-700 border-rose-300 line-through',
};

// Human labels — "partially_refunded" is ugly as-is; keep the key/value
// clean but render "Partial refund" on the pill.
const STATUS_LABEL = {
  partially_refunded: 'Partial refund',
};

export const StatusPill = ({ status }) => (
  <span
    className={`text-[10px] px-1.5 py-0.5 font-bold rounded border uppercase tracking-wider whitespace-nowrap ${STATUS_BADGE[status] || STATUS_BADGE.draft}`}
    data-testid={`status-pill-${status}`}
  >
    {STATUS_LABEL[status] || status}
  </span>
);

// CGST = floor(GST/2) to the paisa, SGST = GST − CGST → always sums to the exact GST.
export const splitGst = (inv) => {
  const igst = Math.round(Number(inv?.igst_total || 0) * 100);
  const tax = Math.round(Number(inv?.tax_total ?? (Number(inv?.cgst_total || 0) + Number(inv?.sgst_total || 0) + igst / 100)) * 100);
  const intra = tax - igst;
  const cgst = Math.floor(intra / 2);
  return { cgst: cgst / 100, sgst: (intra - cgst) / 100, igst: igst / 100, tax: tax / 100 };
};

export const gstMessageLines = (inv) => {
  const f = (n) => `\u20B9${Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  const g = splitGst(inv);
  if (g.tax <= 0) return '';
  const parts = [`Total GST: ${f(g.tax)}`];
  if (g.cgst + g.sgst > 0) parts.push(`  CGST: ${f(g.cgst)}`, `  SGST: ${f(g.sgst)}`);
  if (g.igst > 0) parts.push(`  IGST: ${f(g.igst)}`);
  return `\n${parts.join('\n')}`;
};
